import getLanguageFromStorage from './getLanguageFromStorage';
const getMessage = (pathKeys, dict) => {
    return pathKeys.reduce((subDict, key) => typeof subDict === 'object' && subDict !== null
        ? subDict[key]
        : undefined, dict);
};
const getTranslatedMessage = (resources, language, translationKey, interpolation) => {
    const currentDict = resources[language];
    const pathKeys = translationKey.split('.');
    // handles pluralization if 'count' is present
    if (typeof (interpolation === null || interpolation === void 0 ? void 0 : interpolation.count) === 'number') {
        // find the correct suffix based on count
        const pluralRules = new Intl.PluralRules(language);
        const pluralCategory = pluralRules.select(interpolation.count);
        pathKeys[pathKeys.length - 1] = `${pathKeys.at(-1)}_${pluralCategory}`;
    }
    // it checks the current language dictionary, then falls back to English if it doesn't exist
    let message = getMessage(pathKeys, currentDict) || getMessage(pathKeys, resources.en);
    if (interpolation) {
        message = message.replace(/{{(\w+)}}/g, // matches every string in double curly brackets, captures the string
        (_, key) => { var _a, _b; return (_b = (_a = interpolation[key]) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : `{{${key}}}`; });
    }
    return message;
};
/**
 * For more information read https://syf-agile.atlassian.net/wiki/spaces/DFE/pages/421398663/getTypedTranslation+usage+patterns
 */
const getTypedTranslation = (resources) => {
    const currentLanguage = getLanguageFromStorage();
    const t = (translationKey, interpolation) => getTranslatedMessage(resources, currentLanguage, translationKey, interpolation);
    // type guard to validate strings
    const isSafeLangPath = (value) => typeof getMessage(value.split('.'), resources.en) === 'string';
    /**
     * useful alias for when you need to construct the path through vars
     * e.g tryT(`${foo}.${bar}`)
     */
    const tryT = (translationKey, interpolation) => {
        if (isSafeLangPath(translationKey)) {
            return t(translationKey, interpolation);
        }
        return translationKey;
    };
    return { t, isSafeLangPath, tryT };
};
export default getTypedTranslation;
